import React from "react";
import gallaryImg1 from "../../assets/gallaryImg1.png";
import gallaryImg2 from "../../assets/gallaryImg2.png";
import gallaryImg3 from "../../assets/gallaryImg3.png";
import gallaryImg4 from "../../assets/gallaryImg4.png";
import gallaryImg5 from "../../assets/gallaryImg5.png";
import gallaryImg6 from "../../assets/gallaryImg6.png";
import './ourgallary.css'

export default function GallaryView() {
  return (
    <div className="same_width_container">
      <h6 className="title_gallary_text">
        {" "}
        Our <span>Gallery</span>
      </h6>

      <div className="row_our_gallary_container">
        <div className="left_width_gallary_contanier">
          <img src={gallaryImg3} alt="gallary" loading="lazy" />
        </div>
        <div className="rgt_width_gallary_contanier">
          <img src={gallaryImg2} alt="gallary" loading="lazy" />
          <img src={gallaryImg1} alt="gallary" loading="lazy" />
        </div>
      </div>

      <div className="row_our_gallary_container row_our_gallary_container1">
        <div className="left_width_gallary_contanier left_width_gallary_contanier1">
          <img src={gallaryImg4} alt="gallary" loading="lazy" />
        </div>
        <div className="rgt_width_gallary_contanier">
          <img src={gallaryImg5} alt="gallary" loading="lazy" />
          <img src={gallaryImg6} alt="gallary" loading="lazy" />
        </div>
      </div>
    </div>
  );
}
